/* eslint-disable no-new */
/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';

new Vue({
  render: (h) => h(App),
  mounted() {
    console.log('dispatch render-event')
    document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#download-wrapper', true);